import ZoneSelectView from 'cart-zone-select.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { updateSelectedZone, toggleMiniCart } from '../../redux-state/actions/package-listing.actions';
import { flatMap } from 'lodash';
import { getCartItemDetails } from '../../helpers/cart-helpers';



interface StateToProps {
    zones: Array<IZone>;
    missingPriceTypeSelectionMessage: string;
    selectAZoneDropdownDefaultValue: string;
    selectAZoneLabel: string;
    selectASecondZoneLabel: string;
    requiresPriceTypeSelection: boolean;
    selectedPriceTypeQuantities: Map<number, number>;
    venueZoneMapImageUrl: string;
    venueName: string;
    selectSecondZoneMessageString: string;
    hideZoneSelection: boolean;
}

interface IZoneSelectExternalProps {
    itemId: number;
    selectedZone: IZone;
    disabledZoneIds: Array<number>;
    showPriceTypeError: boolean;
    isSecondZone: boolean;
    hideSeatMap?: boolean;
    showSeatMapOnly: boolean;
}

interface DispatchToProps {
    selectZone: (priceTypeId, quantity) => void;
    toggleMiniCart: (open: boolean) => void;
}

export type ZoneSelectProps = StateToProps & IZoneSelectExternalProps & DispatchToProps;


export class ZoneSelectBase extends React.Component<ZoneSelectProps, any> {
    constructor(props: ZoneSelectProps) {
        super(props);
    }

    render() {
        return <ZoneSelectView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ZoneSelectProps): StateToProps {
    var selectedPriceTypes = [];

    Array.from(state.packageListing.priceTypeQuantity.keys()).forEach(pt => {
        var quantity = state.packageListing.priceTypeQuantity.get(pt);
        var i;
        for (i = 0; i < quantity; i++) {
            selectedPriceTypes.push(pt);
        }

    });

    let itemDetail = getCartItemDetails(state, ownProps.itemId);
    var isSuperPackage = false;

    let performancePricing = state.packageListing.performancePricingList.get(ownProps.itemId);

    if (!performancePricing) {
        isSuperPackage = true;
        performancePricing = state.packageListing.performancePricingList.get(itemDetail.itemIdToRemove);
    }

    var zoneList = performancePricing ? performancePricing.zones
        .filter(z => z.prices.map(pr => pr.priceTypeId)
            .filter(value => -1 !== selectedPriceTypes.indexOf(value)).length > 0
            && (ownProps.disabledZoneIds.length > 0 ? ownProps.disabledZoneIds.indexOf(z.zone.id) < 0 : true)) : [];


    let showZoneSelection = true;
    //For CYO
    if (state.packageListing.packageDetail !== null) {
        let packageMin = state.packageListing.packageDetail.minimumPerformances;
        if (packageMin != 0 && (state.packageListing.cartItems.length == 0 || state.packageListing.cartItems.length < packageMin))
            showZoneSelection = false;
    }
    

    return {
        requiresPriceTypeSelection: selectedPriceTypes.length < 1 && !state.packageListingSettings.useUnseatedReservation,
        zones: isSuperPackage ? zoneList.filter(z => z.performanceId === ownProps.itemId)
            : zoneList,
        selectedPriceTypeQuantities: state.packageListing.priceTypeQuantity,
        missingPriceTypeSelectionMessage: state.packageListingText.missingPriceTypeSelectionMessage,
        selectAZoneLabel: state.packageListingText.selectAZoneLabel,
        selectASecondZoneLabel: state.packageListingText.selectSecondZoneLabel,
        selectAZoneDropdownDefaultValue: state.packageListingText.selectAZoneDropdownDefaultValue,
        venueZoneMapImageUrl: itemDetail.facility.facilityImageUrl,
        venueName: itemDetail.facility.facilityDescription,
        selectSecondZoneMessageString: state.packageListingText.selectSecondZoneMessageString,
        hideZoneSelection : showZoneSelection
    }
}

function mapDispatchToProps(dispatch, ownProps: ZoneSelectProps): DispatchToProps {
    return {
        selectZone: (itemId, zoneId) => {

            // this works for now since we only disable zones for the second choice
            dispatch(updateSelectedZone(itemId, zoneId, ownProps.isSecondZone));
        },
        toggleMiniCart: (open: boolean) => {
            dispatch(toggleMiniCart(open));
        }

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ZoneSelectBase);